import { render, staticRenderFns } from "./data_09m.vue?vue&type=template&id=2c06d872&scoped=true&"
import script from "./data_09m.vue?vue&type=script&lang=js&"
export * from "./data_09m.vue?vue&type=script&lang=js&"
import style0 from "./data_09m.vue?vue&type=style&index=0&id=2c06d872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06d872",
  null
  
)

export default component.exports